/**
 * To minify widget snippet script bundle
 * we use direct require instead of import {words} from 'lodash'
 */
import { latinize } from '../helpers/latin.string.helper';
import kebabCase from 'lodash/kebabCase';

function transformLocationName(name: string): string {
  let preparedName = latinize(name)
    .replace(/['`"]/, '-')
    .replace(/['\u2019]/g, '');

  return kebabCase(preparedName);
}

export const navigationHelper = {
  transformLocationName
};
